interface MatchScrollInput {
  /** Offset of the page container within the scroller. */
  pageOffsetTop: number;
  /** Offset of the match within its page; undefined falls back to the page top. */
  matchTop?: number;
  matchHeight?: number;
  containerHeight: number;
  scrollHeight: number;
}

/**
 * Scroll position that puts a search match in view rather than merely bringing
 * its page into view. The viewer used to scroll to pageOffsetTop, so a match
 * halfway down a tall page left the reader at the page header.
 */
export function computeMatchScrollTop({
  pageOffsetTop,
  matchTop,
  matchHeight = 0,
  containerHeight,
  scrollHeight,
}: MatchScrollInput): number {
  if (matchTop == null) return clamp(pageOffsetTop, containerHeight, scrollHeight);

  const absoluteTop = pageOffsetTop + matchTop;
  // Centring something taller than the viewport would push its start off-screen.
  const target =
    matchHeight >= containerHeight
      ? absoluteTop
      : absoluteTop - (containerHeight - matchHeight) / 2;

  return clamp(target, containerHeight, scrollHeight);
}

function clamp(top: number, containerHeight: number, scrollHeight: number): number {
  const maxScrollTop = scrollHeight - containerHeight;
  // When the scroller reports no scrollable height — a container taller than
  // its content, or jsdom, which leaves scrollHeight at 0 — leave the target
  // alone rather than forcing 0. The browser clamps a real overshoot itself.
  if (maxScrollTop <= 0) return Math.max(0, top);
  return Math.max(0, Math.min(top, maxScrollTop));
}
